import { createSelector } from 'reselect';
import { SORT_VALUE } from '../pages/PatientsPage/components/ShipmentBundling/constants';

export const isShipmentBundlingEnabledSelector = createSelector(
  state => state.patients.globalParams.orderBy,
  orderBy => orderBy === SORT_VALUE
);
